// Mini-cart loyalty banner: sums the per-line LoyaltyLion spans into a total.
// Visibility is only the --has-points class — an inline style would block the
// A/B variant's CSS.

(function () {
  var HAS_POINTS_CLASS = 'mini-cart-loyalty--has-points';
  var NUDGE_SCHEDULE = [0, 3000];
  // Logged-in spans only fill after an auth round-trip, so don't read empty as zero.
  var SETTLE_AFTER_READY_MS = 2000;
  var SETTLE_FALLBACK_MS = 15000;

  var observer = null;
  var settleTimer = null;
  var updateTimer = null;
  var settled = false;
  var lionReady = false;

  // Throws when the drawer has replaced HTML that LoyaltyLion still tracks.
  function refreshLion() {
    if (!(window.loyaltylion && window.loyaltylion.ui && window.loyaltylion.ui.refresh)) return;
    try {
      window.loyaltylion.ui.refresh();
    } catch (e) {}
  }

  function sumPoints(banner) {
    var totalEl = banner.querySelector('[data-mini-cart-loyalty-total]');
    if (!totalEl) return true;

    var units = banner.querySelectorAll('[data-mini-cart-loyalty-unit]');
    if (!units.length) {
      banner.classList.remove(HAS_POINTS_CLASS);
      return true;
    }

    var total = 0;
    var filled = 0;
    units.forEach(function (span) {
      var raw = (span.textContent || '').replace(/[^0-9]/g, '');
      if (raw === '') return;
      filled++;
      var qty = parseInt(span.getAttribute('data-qty'), 10) || 1;
      total += parseInt(raw, 10) * qty;
    });

    // Non-earning products stay empty forever, so settling is the only way out.
    if (filled !== units.length && !settled) return false;

    if (total > 0) {
      totalEl.textContent = total.toLocaleString('en-GB');
      banner.dataset.miniCartLoyaltyResolved = '1';
      banner.classList.add(HAS_POINTS_CLASS);
      return true;
    }

    // LoyaltyLion blanks its spans mid-re-render; that isn't a real zero.
    if (filled === 0 && banner.dataset.miniCartLoyaltyResolved) return false;

    banner.classList.remove(HAS_POINTS_CLASS);
    return false;
  }

  function armSettle(delay) {
    settled = false;
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      settled = true;
      var current = document.querySelector('[data-mini-cart-loyalty]');
      if (current) sumPoints(current);
    }, delay);
  }

  function onLionReady() {
    if (lionReady) return;
    lionReady = true;
    armSettle(SETTLE_AFTER_READY_MS);
    var banner = document.querySelector('[data-mini-cart-loyalty]');
    if (banner && !sumPoints(banner)) refreshLion();
  }

  // loyaltylion.on() only exists once init() has run.
  function watchLion(attempts) {
    if (lionReady) return;
    if (window.loyaltylion && typeof window.loyaltylion.on === 'function') {
      try {
        window.loyaltylion.on('ready', onLionReady);
      } catch (e) {}
      return;
    }
    if (attempts > 0) setTimeout(function () { watchLion(attempts - 1); }, 200);
  }

  function observe(banner) {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    var lion = banner.querySelector('.mini-cart-loyalty__lion');
    if (!lion) return;
    observer = new MutationObserver(function () {
      sumPoints(banner);
    });
    observer.observe(lion, { childList: true, subtree: true, characterData: true });
  }

  function nudge() {
    var done = false;
    NUDGE_SCHEDULE.forEach(function (t) {
      setTimeout(function () {
        if (done) return;
        var current = document.querySelector('[data-mini-cart-loyalty]');
        if (!current || sumPoints(current)) {
          done = true;
          return;
        }
        refreshLion();
      }, t);
    });
  }

  function update() {
    var banner = document.querySelector('[data-mini-cart-loyalty]');
    if (!banner) return;

    armSettle(lionReady ? SETTLE_AFTER_READY_MS : SETTLE_FALLBACK_MS);
    observe(banner);
    nudge();
  }

  function scheduleUpdate() {
    if (updateTimer) clearTimeout(updateTimer);
    updateTimer = setTimeout(function () {
      updateTimer = null;
      update();
    }, 50);
  }

  // Nudges run from page load, so a drawer opened later needs its own re-read.
  function hookDrawerOpen(attempts) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      if (drawer.dataset.miniCartLoyaltyHooked) return;
      drawer.dataset.miniCartLoyaltyHooked = 'true';
      var originalOpen = drawer.open.bind(drawer);
      drawer.open = function (triggeredBy) {
        var result = originalOpen(triggeredBy);
        scheduleUpdate();
        return result;
      };
      return;
    }
    if (attempts > 0) setTimeout(function () { hookDrawerOpen(attempts - 1); }, 200);
  }

  function subscribeToCart(attempts) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleUpdate);
    } else if (attempts > 0) {
      setTimeout(function () { subscribeToCart(attempts - 1); }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  watchLion(150);
  hookDrawerOpen(50);
  subscribeToCart(100);
})();
